import React from 'react';
import { Icon, Typography } from "../ecosystem";

const VerifyEditButton = ({
    onEditClick = () => {},
    isTablet,
    isDesktop
}) => {

    return (
        <button
            type="button"
            onClick={onEditClick}
            className="verify-edit-button"
        >
            <Typography type={isTablet || isDesktop ? "heading-01" : "cta-03"} color="$color-primary-a3" bold>
                Edit
            </Typography>
            <span className="edit-icon">
                <Icon name="edit" size="small" />
            </span>
        </button>
    );
}

export default VerifyEditButton;
